import ModalSwitch from './ModalSwitch';

export default ModalSwitch;
